import styled, { css } from 'styled-components';

export const StyledTabContent = styled.div`
  width: 100%;
  padding: 30px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 0px rgba(204, 204, 204, 0.25);

  .profile-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: relative;
    border-bottom: 1px solid #f1f1f1;
    margin: 0 0 30px;
    padding: 0 0 30px;

    .loader-wrap {
      position: absolute;
      z-index: 1;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(204, 204, 204, 0.25);
      /* background: red; */
    }
    .loader {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      display: inline-block;
      border-top: 3px solid var(--primary);
      border-right: 3px solid transparent;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
      ${({ $lg }) =>
    $lg &&
    css`
          width: 27px;
          height: 27px;
        `}
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .label-text {
      display: none;
    }
    .labelButton {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 0;
      border: none;
      border-radius: 0;
      background-color: white;

      @media (max-width: 575px) {
        height: 160px;
      }

      .icon-img {
        width: 120px;
        height: 120px;
      }
      .text {
        width: max-content;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        border-bottom: 1px solid rgb(75, 150, 237);
      }
    }

  }

  .inputs-wrap {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;
    row-gap: 5px;
    margin-bottom: 12px;
  }
  .account-wrap {
    cursor: pointer;
    margin-bottom: 40px;

    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      margin-bottom: 20px;
    }
    .account {
      display: flex;
      align-items: center;
      gap: 10px;
      color: #1b1f3c;
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
    }
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
  }

  .pagination-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .invoices-table {
    
    .text-center{
      width: 100%;
    }

    table {
      th,
      td {
        &:last-child {
          text-align: right;
        }
      }
    }
  }


  .inner-wrap {
    padding-right: 10px ;

    &::-webkit-scrollbar {
      width: 5px;
    }
  }

  .loading-skeleton{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:20px 5px 20px 15px;

    .loading-skeleton-item{
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
`;

export const StyledTag = styled.span`
      display: block;
      min-width: 90px;
      text-align: center;
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: #317bff;
      position: relative;
      border-radius: 50px;
      padding: 8px 15px 8px 26px;
      background: rgba(49, 123, 255, 0.1);

      &::before {
        content: '';
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: #317bff;
      }
      
      ${({ $SubscriptionCanceled }) => $SubscriptionCanceled && css`
      &::before {
        background: var(--danger);
      }
      color: var(--danger);
      background: rgba(215, 65, 32, 0.1);
      `}
`;

export const UserColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  .user-box {
    flex-grow: 1;
  }

  .user-name {
    display: block;
    font-size: 24px;
    line-height: 27px;
    font-weight: 500;
    color: var(--black);
    text-transform: capitalize;
    margin: 0 0 3px;
  }
  .designation {
    display: block;
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    color: #7f8594;
  }
`;
export const ProfileWrapper = styled.label`
  display: block;
  width: 85px;
  height: 85px;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 50px;
  overflow: hidden;
  background: var(--dark);
  margin-bottom: 0;
  position: relative;
  cursor: pointer;

  .loaderSm {
    display: block;
    position: absolute;
    top: 45%;
    left: 45%;
    transform: translate(-50%, -50%);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &::before {
    position: absolute;
    content: '';
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: 0.3s all ease-in;
  }
  input {
    display: none;
  }
  .rounded-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    visibility: hidden;
  }
  ${({ showEffect }) =>
    showEffect &&
    css`
      &:hover {
        .rounded-icon,
        &::before {
          opacity: 1;
          visibility: visible;
        }
      }
    `}
`;

export const ProfileFormWrap = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex-grow: 1;
  width: 100%;

  .goBack {
    position: absolute;
    top: 0;
    left: 0;
  }

  .form-wrap {
    width: 100%;
    max-width: 650px;
    margin: 0 auto;
  }

  .heading-holder {
    max-width: 460px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
    text-align: center;
    margin: 0 auto 30px;

    .heading {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 700;
      color: var(--text-color-50);
      margin: 0 0 10px;
    }
  }

  .subtitle {
    display: block;
    font-weight: 700;
    font-style: italic;
    color: var(--text-color-50);
    margin: 0 0 15px;
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const NotificationsStyles = styled.div`
  position: relative;
`;
export const StyledLoginWithLinkedinModal = styled.div`
  .list {
    padding-left: 20px;
    margin: 0 0 20px;

    li {
      list-style: decimal;
      margin: 0 0 10px;
    }
  }
  a {
    font-style: italic;
    font-weight: 500;
    color: var(--green);
  }
  .instruction-text {
    display: block;
    margin: 0 0 15px;
  }

  form {
    .input-wrapper {
      display: flex;
      gap: 16px;
    }
    .react-select__control {
      margin-bottom: 25px;
    }

    .btn-holder {
      display: flex;
      justify-content: center;
    }
  }
`;

export const NotificationTabs = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  gap: 18px;
  padding: 5px 0 0;

  .tabset {
    list-style: none;
    margin: 72px 0 0;
    padding: 0;
    width: 250px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e6e7ec;

    li {
      &:last-child {
        .btn-tab {
          border-bottom: 0;
        }
      }
    }

    .btn-tab {
      display: block;
      text-align: left;
      width: 100%;
      font-size: 14px;
      line-height: 17px;
      text-transform: capitalize;
      color: #7f8594;
      padding: 12px 15px;
      border-width: 0 0 1px;
      border-style: solid;
      border-color: #e6e7ec;

      &:hover,
      &.active {
        font-weight: 600;
        color: #2783ec;
        background: rgba(39, 131, 236, 0.05);
      }
    }
  }

  .tabs-content {
    flex-grow: 1;
  }

  .tab-styled {
    width: 100%;

    .header {
      width: 100%;
      margin: 0 0 20px;
      font-size: 16px;
      line-height: 20px;
      color: #9d9d9d;

      .heading {
        display: block;
        font-size: 25px;
        line-height: 28px;
        font-weight: 500;
        color: #313131;
        margin: 0 0 5px;
      }
    }
  }

  .col-wrap {
    /* max-width: 900px; */
    overflow: hidden;
    border: 1px solid #efefef;
    border-radius: 10px;
  }

  .enable-disable-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    border-bottom: 1px solid #efefef;
    padding: 18px 25px;

    &:last-child {
      border: 0;
    }

    .text-box {
      flex-grow: 1;
      font-size: 16px;
      line-height: 20px;
      color: #9d9d9d;

      .title {
        display: block;
        font-size: 18px;
        line-height: 22px;
        font-weight: 600;
        color: #313131;
        margin: 0 0 5px;
      }
    }
  }

  .enable-disable-btns {
    display: flex;
    width: 100%;
    max-width: 175px;
    overflow: hidden;
    border: 1px solid #efefef;
    border-radius: 10px;

    button {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      padding: 12px 20px;
      border: 0;
      transition: 0.3s;
      color: #bac3ce;
      background: #fff;

      &:first-child {
        color: #606060;
        background: #fff;

        &.active {
          color: var(--white);
          background: #c7c7c7;
        }
      }

      &.active {
        color: var(--white);
        border-color: var(--blue);
        background: var(--blue);
      }
    }
  }
`;
export const EditModalStyle = styled.div`
  position: relative;

  .header {
    width: 100%;
    margin: 0 0 20px;

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
      color: #313131;
      margin: 0 0 5px;
    }
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
  }
`;

export const InvoiceCols = styled.div`
  position: relative;
  margin: 0 0 30px;

  @media (min-width: 1200px) {
    display: flex;
    align-items: start;
    gap: 25px;
  }
  @media (min-width: 1450px) {
    gap: 50px;
  }

  .head {
    display: flex;
    align-items: end;
    justify-content: space-between;
    margin: 0 0 20px;

    .title {
      display: block;
      font-size: 24px;
      line-height: 28px;
      font-weight: 500;
      color: var(--black);
    }

    .btn-add {
      font-size: 15px;
      line-height: 18px;
      font-weight: 500;
      color: #2783ec;
    }
  }

  .payment-method {
    flex-grow: 1;
    margin: 0 0 30px;

    @media (min-width: 1200px) {
      margin: 0 0 10px;
    }

    .card-wrap {
      overflow: hidden;
      border-radius: 10px;
      border: 1px solid #efefef;
    }

    .card-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 16px;
      border-bottom: 1px solid #efefef;

      &:last-child {
        border: 0;
      }

      .col {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .img-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 50px;
        border: 1px solid #efefef;
        padding: 10;
        border-radius: 10px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .text-box {
        flex-grow: 1;
      }
      .subtitle {
        display: block;
        font-size: 18px;
        line-height: 22px;
        color: #1c1c1c;
        font-weight: 700;
      }
      .exp-date {
        display: block;
        font-size: 16px;
        line-height: 20px;
        color: #7f8594;
        font-weight: 400;
      }
      .btn-set {
        display: inline-block;
        font-size: 15px;
        line-height: 18px;
        font-weight: 500;
        color: #2783ec;
        border-radius: 50px;
        text-align: center;
        padding: 10px 16px;

        &:hover,
        &.active {
          color: var(--white);
          background: var(--black);
        }
      }

      .btn-delete {
        display: inline-block;
        font-size: 20px;
        line-height: 1;
        color: #7f8594;

        &:hover {
          color: var(--danger);
        }
      }
    }
  }

  .current-plan {
    width: 100%;
    margin: 0 0 10px;

    @media (min-width: 1200px) {
      max-width: 440px;
    }

    .plan-wrap {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 20px;
      border-radius: 16px;
      border: 1px solid #efefef;
      margin: 0 0 12px;

      .status {
        min-width: 85px;
        position: absolute;
        top: -25px;
        right: 26px;
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
        color: #01c638;
        text-transform: capitalize;
        padding: 3px;
        text-align: center;
        border-radius: 10px 10px 0 0;
        background: rgba(1, 198, 56, 0.12);
      }
    }

    .plan-box {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;

      .icon-box {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 5px;
        border-radius: 15px;
        background: #fafafa;
      }

      .text-box {
        display: inline-block;
        position: relative;
      }
      .plan-text {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        text-transform: capitalize;
        color: var(--text-color-50);
      }
    }

    .price-box {
      display: flex;
      align-items: center;
      gap: 10px;

      .price {
        display: block;
        font: 500 36px/40px var(--roboto-font-serif);
        color: var(--text-color-50);
      }
      .duration {
        display: block;
        font-size: 16px;
        line-height: 19px;
        color: var(--text-color-50);
      }
      .text {
        display: block;
        font-size: 13px;
        line-height: 16px;
        color: rgba(136, 133, 129, 0.5);
      }
    }
  }
`;

export const EnterCardStyle = styled.div`
  position: relative;

  .header {
    width: 100%;
    margin: 0 0 20px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    color: #9d9d9d;

    .title {
      display: block;
      font-size: 24px;
      line-height: 28px;
      font-weight: 600;
      color: #313131;
      margin: 0 0 5px;
    }
  }

  .input-wrapper {
    position: relative;

    .label-text {
      display: block;
      font-size: 14px;
      line-height: 17px;
      text-transform: capitalize;
      font-weight: 400;
      color: var(--text-color-50);
      margin: 0 0 10px;
    }

    .inputs-holder {
      overflow: hidden;
      border-radius: 10px;
      border: 1px solid #e7eaeb;
      margin: 0 0 20px;

      .input-box {
        display: flex;
        align-items: center;
        gap: 5px;
        position: relative;
        border-bottom: 1px solid #e7eaeb;

        .img {
          display: inline-block;
          max-width: 100%;
          margin: 0 10px 0 0;
        }
      }

      .wrap {
        display: flex;
        position: relative;

        .input-box {
          width: 50%;
          flex-grow: 1;
          border-width: 0 0 0 1px;
          border-style: solid;
          border-color: #e7eaeb;

          &:first-child {
            border: 0;
          }
        }
      }

      input {
        width: 100%;
        height: 42px;
        padding: 10px 15px;
        border: 0;
        outline: none;
        box-shadow: none;
      }
    }
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
  }
`;
